import type { CMPCustomFilter } from '@atlassian/jira-software-filters/src/common/types.tsx';

/**
 * @deprecated Use `LOAD_CONFIG_DATA_MODEL_SUCCESS`. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export const SET_CUSTOM_FILTERS = 'state.actions.custom-filters.SET_CUSTOM_FILTERS';

/**
 * @deprecated Use `LOAD_CONFIG_DATA_MODEL_SUCCESS`. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export interface SetCustomFiltersAction {
	type: typeof SET_CUSTOM_FILTERS;
	payload: CMPCustomFilter[];
}

/**
 * @deprecated Use `LOAD_CONFIG_DATA_MODEL_SUCCESS`. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export function setCustomFilters(customFilters: CMPCustomFilter[]): SetCustomFiltersAction {
	return {
		type: SET_CUSTOM_FILTERS,
		payload: customFilters,
	};
}

export type CustomFilterAction = SetCustomFiltersAction;
